/**
 * Wrapper that provides v3 GarnerComponentsWrapper context for GarnerMap.
 *
 * GarnerMap (from components-common v3) uses v3 theme hooks (useLog,
 * useFocusVisibilityStyles) that require the v3 GarnerComponentsWrapper
 * context. Since the rest of the app uses v0 GarnerThemeProvider, we
 * wrap GarnerMap in its own v3 context.
 *
 * Remove this wrapper once the app is fully migrated to components-common v3.
 */
import type { MapProps } from '@garner-health/components-map-v3';
import { GarnerComponentsWrapper, GarnerMap } from '@garner-health/components-map-v3';
import React from 'react';

export const WrappedGarnerMap = (props: MapProps) => (
  <GarnerComponentsWrapper locale="en-US">
    <GarnerMap {...props} />
  </GarnerComponentsWrapper>
);
